var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon_location"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1347_10526",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1347_10526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "location_on",
    d: "M9.99992 9.99935C10.4583 9.99935 10.8506 9.83615 11.177 9.50977C11.5034 9.18338 11.6666 8.79102 11.6666 8.33268C11.6666 7.87435 11.5034 7.48199 11.177 7.1556C10.8506 6.82921 10.4583 6.66602 9.99992 6.66602C9.54158 6.66602 9.14922 6.82921 8.82284 7.1556C8.49645 7.48199 8.33325 7.87435 8.33325 8.33268C8.33325 8.79102 8.49645 9.18338 8.82284 9.50977C9.14922 9.83615 9.54158 9.99935 9.99992 9.99935ZM9.99992 16.1243C11.6944 14.5688 12.9513 13.1556 13.7708 11.8848C14.5902 10.6139 14.9999 9.48546 14.9999 8.49935C14.9999 6.98546 14.5173 5.74588 13.552 4.7806C12.5867 3.81532 11.4027 3.33268 9.99992 3.33268C8.59714 3.33268 7.41311 3.81532 6.44784 4.7806C5.48256 5.74588 4.99992 6.98546 4.99992 8.49935C4.99992 9.48546 5.40964 10.6139 6.22909 11.8848C7.04853 13.1556 8.30547 14.5688 9.99992 16.1243ZM9.99992 18.3327C7.76381 16.4299 6.09367 14.6625 4.9895 13.0306C3.88534 11.3987 3.33325 9.88824 3.33325 8.49935C3.33325 6.41602 4.00339 4.75629 5.34367 3.52018C6.68395 2.28407 8.23603 1.66602 9.99992 1.66602C11.7638 1.66602 13.3159 2.28407 14.6562 3.52018C15.9964 4.75629 16.6666 6.41602 16.6666 8.49935C16.6666 9.88824 16.1145 11.3987 15.0103 13.0306C13.9062 14.6625 12.236 16.4299 9.99992 18.3327Z",
    fill: "#646D75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/address_icon.f826682742862444c7d04fbf2cf9fc8c.svg";
export { ForwardRef as ReactComponent };